"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var overview_field_type_1 = require("./overview-field-type");
/**
 * Single field of [overview card / portfolio field] configurations.
 */
var OverviewContentPortfolioFieldModel = /** @class */ (function () {
    function OverviewContentPortfolioFieldModel(overviewPortfolioFieldType, fieldName, aggregateConfig) {
        this.overviewPortfolioFieldType = overviewPortfolioFieldType;
        this.fieldName = fieldName;
        this.aggregateConfig = aggregateConfig;
        this.overviewPortfolioFieldType = overviewPortfolioFieldType || overview_field_type_1.OverviewPortfolioFieldType.FIELD;
        this.fieldName = fieldName || null;
        this.aggregateConfig = aggregateConfig || null;
    }
    return OverviewContentPortfolioFieldModel;
}());
exports.OverviewContentPortfolioFieldModel = OverviewContentPortfolioFieldModel;
//# sourceMappingURL=overview-content-field.model.js.map